import { useEffect, useMemo, useState } from "react";
import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import { vehicleActions } from "../../service/vehicle.actions";
import { IChooseVehicle } from "./VehicleSearch";
import {
  ColDef,
  ICellRendererParams,
  IServerSideGetRowsParams,
} from "ag-grid-enterprise";
import EmptyStateGrid from "../common/EmptyStateGrid";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { customTheme } from "../../../../config/theme/MuiTheme";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import { nameof } from "../common/ObjectUtils";
import dayjs from "dayjs";
import ChecklistType from "./ChecklistType";
import AgGridOperationTable from "../common/AgGridOperationTable";

interface Props {
  tenant: string;
  openChecklistModal: boolean;
  setOpenChecklistModal: any;
  chooseVehicle: IChooseVehicle | undefined;
}
const ChecklistModal = (props: Props) => {
  const t = useOperationTranslation();
  const [defaultTotalElements, setDefaultTotalElements] = useState<number>(1);
  const [createDate, setCreateDate] = useState<string | null>(null);
  const [gridApi, setGridApi] = useState<any>(null);
  const columnDefs: ColDef[] = [

    {
      headerName: t("vehicle.checkList.description"),
      field: `${nameof<ChecklistType.CheckListItemsType>("name")}`,
      minWidth: 640,
      maxWidth: 640,
      cellRenderer: (
        props: ICellRendererParams<ChecklistType.CheckListItemsType>
      ) => addTooltipTable(props.value),
    },

    {
      headerName: t("vehicle.checkList.checked"),
      field: `${nameof<ChecklistType.CheckListItemsType>("checked")}`,
      minWidth: 140,
      maxWidth: 140,
      cellRenderer: (
        props: ICellRendererParams<ChecklistType.CheckListItemsType>
      ) => formatChecked(props.value),
    },
  ];

  const formatChecked = (value: boolean) => {
    return (
      <Mui.Box>
        {value ? (
          <MuiIcons.CheckCircle fontSize="inherit" color="success" />
        ) : (
          <MuiIcons.Cancel fontSize="inherit" color="error" />
        )}
      </Mui.Box>
    );
  };
  const addTooltipTable = (name: string) => {
    return (
      <>
        <Mui.Tooltip title={name}>
          <span>{!!name ? name : ""}</span>
        </Mui.Tooltip>
      </>
    );
  };

  const onClose = () => {
    props.setOpenChecklistModal(false);
  };

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };
  function managerData(response: any) {
    setDefaultTotalElements(response.checkListItems.length);
    setCreateDate(response.createDatetime)
    let rows: any[] = [];
    response.checkListItems.forEach((element: any) => {
      let row = {
        name: element.name,
        checked: element.checked,
      };
      rows.push(row);
    });
  
    return rows;
  }
 
  function checklistData(){
    return {
      getRows: (params: IServerSideGetRowsParams) => {
        if(props?.chooseVehicle?.id)
        {
          vehicleActions()
        .vehicleChecklist(props?.chooseVehicle?.id, props.tenant)
          .then((response: any) => {
            params.successCallback(
              managerData(response),
              response.checkListItems.length
            );
            

          })
        }
      },
    };
}

useEffect(() => {
  if (gridApi) {
    gridApi.setServerSideDatasource(checklistData());
  }
}, [gridApi,props.tenant]);
  // const checklistDataSource: IServerSideDatasource = useMemo(
  //   () => ({
  //     getRows: (params: IServerSideGetRowsParams) => {
  //       if (props?.chooseVehicle?.id)
  //         vehicleActions()
  //           .vehicleChecklist(props?.chooseVehicle?.id, props.tenant)
  //           .then((response: any) => {
  //             if(gridApi)
  //             params.success({
  //               rowData: response.checkListItems,
  //               rowCount: response.checkListItems.length,
  //             });
  //             setDefaultTotalElements(response.checkListItems.length);
  //             setCreateDate(response.createDatetime);
  //           });
  //     },
  //   }),
  //   [gridApi,props.tenant]
  // );
  return (
    <>
      <Mui.Dialog
        open={props.openChecklistModal}
        //aria-labelledby="draggable-dialog-title"
        maxWidth={"md"}
        fullWidth
      >
        <Mui.DialogTitle>
          <Mui.Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Mui.Grid item>
              <Mui.Typography variant="h5">
                {t("vehicle.checkList.title")}
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid item>
              <Mui.Stack direction={"row"} spacing={1}>
                <Mui.Typography
                  color={customTheme.palette.accent.main}
                  variant="body"
                  component={"span"}
                >
                  {t("vehicle.checkList.plate")}{" "}
                  <Mui.Typography
                    variant="h6"
                    color={customTheme.palette.accent.main}
                    component={"span"}
                  >
                    {props.chooseVehicle?.plate}
                  </Mui.Typography>
                </Mui.Typography>
                <Mui.Typography
                  color={customTheme.palette.accent.main}
                  variant="h6"
                  component={"span"}
                >
                  -
                </Mui.Typography>
                <Mui.Typography
                  color={customTheme.palette.accent.main}
                  variant="body"
                  component={"span"}
                >
                  {t("vehicle.checkList.vin")}{" "}
                  <Mui.Typography
                    variant="h6"
                    color={customTheme.palette.accent.main}
                    component={"span"}
                  >
                    {props.chooseVehicle?.vin}
                  </Mui.Typography>
                </Mui.Typography>
                <Mui.Button
                  variant="text"
                  size="icon"
                  color="accent"
                  onClick={onClose}
                >
                  <MuiIcons.Close />
                </Mui.Button>
              </Mui.Stack>
            </Mui.Grid>
          </Mui.Grid>
        </Mui.DialogTitle>
        <Mui.DialogContent>
          <Mui.Box>
            <Mui.Grid container>
              {!!defaultTotalElements && (
                <Mui.Grid item xl={12} lg={12} md={12} xs={12}>
                  <Mui.Card>
                    <Mui.Box p={1}>
                      <Mui.Typography
                        color={customTheme.palette.accent.main}
                        variant="body"
                        component={"span"}
                      >
                        {t("vehicle.checkList.createDateTime")}{" "}
                        <Mui.Typography
                          color={customTheme.palette.accent.main}
                          variant="h6"
                          component={"span"}
                        >
                          {dayjs(createDate).format("DD/MM/YYYY HH:mm")}
                        </Mui.Typography>
                      </Mui.Typography>
                    </Mui.Box>
                  </Mui.Card>
                </Mui.Grid>
              )}
              <Mui.Grid item xl={12} lg={12} md={12} xs={12}>
                <AgGridOperationTable
                  columnDefs={columnDefs}
                  onGridReady={onGridReady}
                  serverSideInfiniteScroll={true}
                  rowModelType={"serverSide"}
                  pagination={false}
                  paginationPageSize={500}
                  cacheBlockSize={500}
                  domLayout={'autoHeight'}
                  totalElements={defaultTotalElements}
				  emptyState={{
                    title: t("vehicle.checkList.emptyTitle"),
                    content: t("vehicle.checkList.emptyContent")
                  }}
                />

              </Mui.Grid>
            </Mui.Grid>
          </Mui.Box>
        </Mui.DialogContent>
      </Mui.Dialog>
    </>
  );
};

export default ChecklistModal;
